"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _lodash = _interopRequireDefault(require("lodash.get"));

var _arrify = _interopRequireDefault(require("arrify"));

var _formik = require("formik");

var _Typeahead = _interopRequireDefault(require("../../Typeahead"));

var _FormikValidation = _interopRequireDefault(require("../FormikValidation"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var FormikTypeahead = function FormikTypeahead(_ref) {
  var name = _ref.name,
      options = _ref.options,
      isMultiSelect = _ref.isMultiSelect,
      maxLength = _ref.maxLength,
      onAdd = _ref.onAdd,
      storeValue = _ref.storeValue,
      label = _ref.label,
      formik = _ref.formik,
      validation = _ref.validation,
      props = _objectWithoutPropertiesLoose(_ref, ["name", "options", "isMultiSelect", "maxLength", "onAdd", "storeValue", "label", "formik", "validation"]);

  var setSelected = function setSelected(items) {
    var newItems = items;
    formik.setFieldTouched(name);

    if (storeValue) {
      newItems = items.map(function (itemId) {
        return options.find(function (option) {
          return option.id === itemId;
        });
      });
    }

    if (isMultiSelect) {
      formik.setFieldValue(name, newItems);
    } else {
      formik.setFieldValue(name, (0, _lodash.default)(newItems, '0', ''));
    }
  };

  var setAdd = function setAdd(input) {
    var newItem = onAdd(input);
    var newValue = storeValue ? newItem : newItem.id;

    if (isMultiSelect) {
      formik.setFieldValue(name, [newValue].concat((0, _lodash.default)(formik.values, name, [])));
    } else {
      formik.setFieldValue(name, newValue);
    }
  };

  var getSelectedItems = function getSelectedItems() {
    return (0, _arrify.default)((0, _lodash.default)(formik.values, name)).map(function (v) {
      return v.id || v.uid || v;
    });
  };

  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Typeahead.default, _extends({}, props, {
    label: label,
    setSelected: setSelected,
    maxLength: maxLength,
    options: options,
    selectedItems: getSelectedItems(),
    isMultiSelect: isMultiSelect,
    hasError: !!(0, _lodash.default)(formik.errors, name) && !!(0, _lodash.default)(formik.touched, name),
    onAdd: onAdd ? setAdd : undefined
  })), validation && _react.default.createElement(_FormikValidation.default, {
    name: name
  }));
};

FormikTypeahead.defaultProps = _objectSpread({}, _Typeahead.default.defaultProps, {
  onAdd: undefined,
  storeValue: false,
  validation: true
});
FormikTypeahead.propTypes = _objectSpread({
  name: _propTypes.string.isRequired
}, _Typeahead.default.propTypes, {
  onAdd: _propTypes.func,
  storeValue: _propTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  formik: _propTypes.any.isRequired,
  validation: _propTypes.bool
});

var _default = (0, _formik.connect)(FormikTypeahead);

exports.default = _default;